export default {
  methods: {
    /**
     * Commented.by.KWShin.2024.02.14.
     * router query로 날짜가 넘어오면
     * 실시간 모드를 false로 바꾸고, 넘어온 시각을 넘겨준다.
     */
    referer() {
      const datetime = parseInt(this.$route.query.t ?? 0);
      if (datetime) {
        this.activeIncrement = false;
        this.datetime = new Date(datetime);
      }
    },
    // BEGIN::Added.by.KWShin.2023.08.12.
    referTab() {
      const sttsCode = this.$route.query.c;
      if (!sttsCode) return; // 링크되어 들어온 경우가 아니어서 c 값이 없으면 그냥 리턴.
      if (sttsCode == 'stts-syslog') {
        this.selectedTab = 1;
        this.tabChanged(1);
      } else if (sttsCode == 'stts-applog') {
        this.selectedTab = 2;
        this.tabChanged(2);
      } else {
        this.selectedTab = 0;
        this.tabChanged(0);
      }
    },
    // FINISH::Added.by.KWShin.2023.08.12.
  },
};
